<template>
  <div class="canvas-footer">
    <CanvasFilter />
    <div class="credits">
      <img
        :src="`${baseUrl}assets/images/musement-icon.svg`"
        alt="musement icon"
      />
      <span class="text">{{ $ml.get("content").credits }}</span>
      <a
        class="tva"
        :href="
          `https://thevisualagency.com${$ml.current !== 'it' ? '/en/' : ''}`
        "
        target="_blank"
        >&nbsp;The Visual Agency</a
      >
    </div>
    <div class="footer-shadow"></div>
  </div>
</template>

<script>
import CanvasFilter from "@/components/CanvasFilter.vue";
export default {
  name: "canvas-footer",
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  components: {
    CanvasFilter
  }
};
</script>

<style lang="scss" scoped>
.canvas-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  pointer-events: none;
  @media (max-width: 720px) {
    padding: 0 15px;
  }
  .credits {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 15px 0 10px;
    @include dida-small-white;
    font-size: 13px;
    pointer-events: initial;
    span,
    img {
      display: inline-block;
    }
    img {
      margin-top: -2px;
    }
    .text {
      border-left: solid 1px $white;
      padding-left: 9px;
      margin-left: 9px;
    }
    .tva {
      @include dida-small-primary;
      font-size: 13px;
    }
  }
  .footer-shadow {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 148px;
    transform: rotate(-180deg);
    background-image: linear-gradient(
      to bottom,
      rgba(21, 15, 10, 0.78),
      rgba(21, 15, 10, 0.39) 53%,
      rgba(21, 15, 10, 0)
    );
    z-index: -1;
  }
}
</style>
